import { UserProfile, Session, UserMeData } from "@/types/profile";
import { rpcApi, RPCResponse } from "./rpc";
import { PROFILE_UPDATE_DELAY } from "@/utils/constants";

interface RPCResponseWithData<T> extends RPCResponse<T> {
    data?: {
        result?: T;
    };
}

export const profileApi = {
    getUserData: async (authData?: { token?: string | null; userName?: string | null; userEmail?: string | null }): Promise<{ profile: UserProfile; sessions: Session[]; totpEnabled: boolean; ftpData?: UserMeData['ftp']; token?: string }> => {
        try {
            const response = await rpcApi.getUserMe() as RPCResponseWithData<UserMeData>;

            const userData = response?.result || response?.data?.result;

            if (userData) {
                const profile: UserProfile = {
                    id: userData.id,
                    name: userData.name || authData?.userName || "User",
                    email: userData.email || authData?.userEmail || "",
                    phone: userData.phone || "",
                    role: userData.user_role || "User",
                    permissions: userData.permissions || [],
                    decoded_permissions: userData.decoded_permissions || [],
                    user_req: userData.user_req || [],
                    business: userData.business_name || undefined,
                    team: userData.team_name || undefined,
                };

                const sessions: Session[] = userData.session || [];
                const totpEnabled = userData.totp?.enabled === true;
                const ftpData = userData.ftp;
                const responseToken = userData.token;

                return { profile, sessions, totpEnabled, ftpData, token: responseToken };
            }

            return {
                profile: {
                    id: undefined,
                    name: authData?.userName || "User",
                    email: authData?.userEmail || "",
                    phone: "",
                    role: "User",
                    permissions: [],
                    decoded_permissions: [],
                    user_req: [],
                    business: undefined,
                    team: undefined,
                },
                sessions: [],
                totpEnabled: false,
                ftpData: undefined,
                token: undefined
            };
        } catch (error) {
            console.error('Failed to get user data:', error);
            return {
                profile: {
                    id: undefined,
                    name: authData?.userName || "User",
                    email: authData?.userEmail || "",
                    phone: "",
                    role: "User",
                    permissions: [],
                    decoded_permissions: [],
                    user_req: [],
                    business: undefined,
                    team: undefined,
                },
                sessions: [],
                totpEnabled: false,
                ftpData: undefined,
                token: undefined
            };
        }
    },

    updateProfile: async (data: UserProfile): Promise<UserProfile> => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(data);
            }, PROFILE_UPDATE_DELAY);
        });
    },

    revokeSession: async (sessionId: string, userId: string): Promise<unknown> => {
        const response = await rpcApi.revokeSession(sessionId, userId) as RPCResponseWithData<unknown>;
        const result = response?.result || response?.data?.result;
        if (result) {
            return result;
        }
        return null;
    },

    requestService: async (requests: Array<{ business: string; team: string; service: string; id: string }>): Promise<unknown> => {
        const response = await rpcApi.requestService(requests) as RPCResponseWithData<unknown>;
        const result = response?.result || response?.data?.result;
        if (result) {
            return result;
        }
        const errorMessage =
            typeof response?.error === "string"
                ? response.error
                : typeof response?.error === "object" && response?.error?.message
                ? String(response.error.message)
                : response?.message ?? "Failed to send request";
        throw new Error(errorMessage);
    },

};
